import React from 'react';
import PropTypes from 'prop-types';

import {Button, Grid, Typography} from 'views/components';

import {Translate} from 'views/module';

const EditButtons = (props) => {
  const {
    onAddWidget,
    onReset,
    onCancel,
    onSave,
  } = props;

  return (
    <Grid container spacing={1} sx={{minWidth: {md: '600px', xs: '100%'}}}>
      <Grid item md={3} xs={6}>
        <Button variant='outlined' onClick={onAddWidget} fullWidth>
          <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
            <Translate expression='dashboard.Customization.AddWidget'/>
          </Typography>
        </Button>
      </Grid>
      <Grid item md={3} xs={6}>
        <Button variant='outlined' onClick={onReset} fullWidth>
          <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
            <Translate expression='dashboard.Customization.Reset'/>
          </Typography>
        </Button>
      </Grid>
      <Grid item md={3} xs={6}>
        <Button color='error' onClick={onCancel} fullWidth>
          <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'white'}}>
            <Translate expression='generic.Cancel'/>
          </Typography>
        </Button>
      </Grid>
      <Grid item md={3} xs={6}>
        <Button color='primary' onClick={onSave} fullWidth>
          <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'white'}}>
            <Translate expression='generic.Save'/>
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

EditButtons.propTypes = {
  onAddWidget: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditButtons;
